import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { FocusOnFirstInvalidFieldModule } from '@go-modules/directives/focus-on-first-invalid-field';
import { ManageLibraryCollectionFolderComponent } from './manage-library-collection-folder.component';
import {
	FolderTreeSelectComponent
} from '@go-modules/components/library/manage-library-collection-folder/folder-tree-select/folder-tree-select.component';
import { RequiredFieldsNoteDirective } from '@go-modules/directives/required-fields-note';
import { GoDialogContentDirective } from '@go-modules/directives/go-dialog-content/go-dialog-content.directive';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		A11yModule,
		FocusOnFirstInvalidFieldModule,
		FolderTreeSelectComponent,
		RequiredFieldsNoteDirective,
		GoDialogContentDirective
	],
	declarations: [
		ManageLibraryCollectionFolderComponent
	],
	exports: [
		ManageLibraryCollectionFolderComponent
	]
})
export class ManageLibraryCollectionFolderModule {}
